import React, { useContext } from "react";
import LanguageContext from "../../components/Language/LanguageContext";

const PlayStore = () => {
  const { language, messages, changeLanguage } = useContext(LanguageContext);
  return (
    <>
      <div className="surface-section px-4 py-8 md:px-6 lg:px-8">
        <div
          className="p-6 shadow-2 flex flex-column md:flex-row align-items-center justify-content-between"
          style={{
            borderRadius: "1rem",
            background:
              "linear-gradient(0deg, rgba(0, 123, 255, 0.5), rgba(0, 123, 255, 0.5)), linear-gradient(92.54deg, #1C80CF 47.88%, #FFFFFF 100.01%)",
          }}
        >
          <div className="pr-6">
            <div
              className="font-medium text-xl mb-3"
              style={{ color: "white" }}
            >
              {messages.playStoreAnakJudul}
            </div>
            <div className="text-white font-medium text-5xl">
              {messages.playStoreJudul}
            </div>
          </div>
          <div className="mt-4 mr-auto md:mt-0 md:mr-0">
            <div className="store-buttons">
              <a href="https://play.google.com/store/apps/details?id=com.enerren.smartsafetee">
                <div className="google-play-button">
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                    alt="Google Play"
                    className="google"
                  />
                </div>
              </a>
              <a href="https://appsource.microsoft.com/en-us/product/saas/ptenerrentechnologies1689724498932.smartsafetee?tab=Overview">
              <img
                src="/images/PlayStore/Microsoft_logo1.png"
                alt="Microsoft Logo"
                className="microsoft mt-2"
                width={170}
              />
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PlayStore;